import { apiSlice } from "app/api/apiSlice";

export const UserManagementApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllEmployee: builder.query({
      query: ({ orgId, pagination, searchKey, stateId, districtId }) => {
        let queryString = `/api/v1/onboarding/employees?page=${pagination.page}&per_page=50&q=${searchKey}&state_code=${stateId}&district_code=${districtId}`;
        if (orgId) {
          queryString += `&organization_id=${orgId}`;
        }
        return queryString;
      },
    }),

    getAllPosp: builder.query({
      query: ({ pagination, searchKey }) =>
        `/api/v1/onboarding/employees/POSP?page=${pagination.page}&per_page=200&q=${searchKey}`,
    }),

    getEmployeeById: builder.query({
      query: (id) => `/api/v1/onboarding/employees/${id}`,
    }),
    addEmployee: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/onboarding/employees",
        method: "POST",
        body: payload,
      }),
    }),
    updateEmployee: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/onboarding/employees/${id}`,
        method: "PATCH",
        body: payload,
      }),
    }),
    getuserDailyAttendanceReport: builder.query({
      query: ({ id }) => `/survey/visit-report/attendance?agent_id=${id}`,
    }),
    getAttendancebyId: builder.query({
      query: (id) => `/survey/visit-report/attendance/${id}`,
    }),
    AddorUpdateReportingManager: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/onboarding/employees/${id}`,
        method: "PATCH",
        body: payload,
      }),
    }),
    getAllSessionsById: builder.query({
      query: (id) => `/api/v1/auth/user/${id}/sessions`,
    }),

    removeSingleSession: builder.mutation({
      query: ({ id }) => ({
        url: `/api/v1/auth/sessions/${id}`,
        method: "DELETE",
      }),
    }),
    logoutAlleSessions: builder.mutation({
      query: ({ id }) => ({
        url: `/api/v1/auth/user/${id}/logout`,
        method: "DELETE",
      }),
    }),
    getAllVisitReport: builder.query({
      query: (pagination) => `/survey/visit-report/daily-visit?&per_page=${pagination.limit}&page=${pagination.currentPage}`,
    }),
    getAllPosp: builder.query({
      query: ({ pagination, searchKey }) =>
        `/api/v1/onboarding/employees/POSP?page=${pagination.page}&per_page=200&q=${searchKey}`,
    }),

    getEmployeeById: builder.query({
      query: (id) => `/api/v1/onboarding/employees/${id}`,
    }),
    addEmployee: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/onboarding/employees",
        method: "POST",
        body: payload,
      }),
    }),
    updateEmployee: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/onboarding/employees/${id}`,
        method: "PATCH",
        body: payload,
      }),
    }),
    getuserDailyAttendanceReport: builder.query({
      query: ({ id }) => `/survey/visit-report/attendance?agent_id=${id}`,
    }),
    getAttendancebyId: builder.query({
      query: (id) => `/survey/visit-report/attendance/${id}`,
    }),
    AddorUpdateReportingManager: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/onboarding/employees/${id}`,
        method: "PATCH",
        body: payload,
      }),
    }),
    getAllSessionsById: builder.query({
      query: (id) => `/api/v1/auth/user/${id}/sessions`,
    }),

    removeSingleSession: builder.mutation({
      query: ({ id }) => ({
        url: `/api/v1/auth/sessions/${id}`,
        method: "DELETE",
      }),
    }),
    logoutAlleSessions: builder.mutation({
      query: ({ id }) => ({
        url: `/api/v1/auth/user/${id}/logout`,
        method: "DELETE",
      }),
    }),
    getAllVisitReport: builder.query({
      query: (pagination) => `/survey/visit-report/daily-visit?&per_page=${pagination.limit}&page=${pagination.currentPage}`,
    }),

    getAllAttendanceReport: builder.query({
      query: (pagination) =>
         `/survey/visit-report/attendance?&per_page=${pagination.limit}&page=${pagination.currentPage}`
      
      
    }),
  

    deleteUser: builder.mutation({
      query: ({ id }) => ({
        url: `/api/v1/onboarding/employees/${id}`,
        method: "DELETE",
      }),
    }),
    getRoleListData: builder.query({
      query: ({ pagination, roles }) =>
        `/api/v1/onboarding/employees/${roles}?page=${pagination.page}&per_page=200`,
    }),
  }),
});

export const {
  useGetAllEmployeeQuery,
  useAddEmployeeMutation,
  useGetEmployeeByIdQuery,
  useUpdateEmployeeMutation,
  useGetuserDailyAttendanceReportQuery,
  useAddorUpdateReportingManagerMutation,
  useGetAttendancebyIdQuery,
  useGetAllPospQuery,
  useGetAllSessionsByIdQuery,
  useRemoveSingleSessionMutation,
  useLogoutAlleSessionsMutation,
  useGetAllVisitReportQuery,
  useGetAllAttendanceReportQuery,
  useDeleteUserMutation,
  useGetRoleListDataQuery,
} = UserManagementApiSlice;
